/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import VueQrcodeReader from "vue-qrcode-reader";
import VueSweetalert2 from 'vue-sweetalert2';
import Multiselect from 'vue-multiselect';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';


require('./bootstrap');

window.Vue = require('vue');

export const serverBus = new Vue();

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.use(VueQrcodeReader);
Vue.use(VueSweetalert2);
Vue.component('multiselect', Multiselect);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);


Vue.component('multiselect-component', require('./components/form/MultiselectComponent.vue').default);
Vue.component('date-picker-component', require('./components/form/DatePickerComponent.vue').default);
Vue.component('time-picker-component', require('./components/form/TimePickerComponent.vue').default);
Vue.component('datetime-picker-component', require('./components/form/DatetimePickerComponent.vue').default);
Vue.component('clock-component', require('./components/ClockComponent.vue').default);
Vue.component('qrcode-reader-component', require('./components/QrcodeReaderComponent.vue').default);
Vue.component('qrcard-component', require('./components/QRCardComponent.vue').default);
Vue.component('qrcard-with-btn-component', require('./components/QRCardWithBtnComponent.vue').default);
Vue.component('shift-component', require('./components/ShiftComponent.vue').default);
//Vue.component('working-hours-chart-component', require('./components/WorkingHoursChartComponent.vue').default);
//Vue.component('user-calendar-component', require('./components/user/UserCalendarComponent.vue').default);
//Vue.component('user-attendance-data-component', require('./components/user/UserAttendanceDataComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
